import React from 'react';
// import { isSafari } from '~utils/helpers';
import Block from '~routes/main/userprofile/block';
import Spinner from '~components/spinner';
import '../../TabFeed.scss';
import '../Feed.scss';

function TabFeed() {
    // const windowWidth = isSafari() ? document.documentElement.clientWidth : window.innerWidth;
    // const isMobile = windowWidth < 1160;
    return (
        <div className="feed">
            <Block>
                <div className="feed__loader">
                    <Spinner />
                </div>
            </Block>
        </div>
    );
}

export default TabFeed;
export { TabFeed };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/tab-feed/feed/loader/index.js